import React, { useRef, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TopBar from '../other-components/TopBar';
import LoadingDialog from '../dialogs/LoadingDialog/dialog';
import '../../MainStyle.css';
import { API_ACCESS_URL, copyText } from '../modals/Constants';
import { getStorage } from '../modals/Storage';
import ToastDialog from '../dialogs/ToastDialog/toast';

function AllBankCards() {
  const toastDialogRef = useRef(null);
  const navigate = useNavigate();
  const listViewRef = useRef();
  const [showLoading, setShowLoading] = useState(false);

  const [pageConst, setConstants] = useState({
    pageTitle: "Withdraw Records",
    pageCount: 1,
    recordList: [],
  });

  // toast component
  const onToastChange = (data, msg) => { };

  const showToast = (message, duration, delay, mode) => {
    toastDialogRef.current.openDialog(message, duration, delay, mode);
  };

  const onIDClicked = (id) => {
    if (id !== "") {
      copyText(id);
      showToast("ID Copied!", 2500, 0, 1);
    }
  };

  const topBarClickAction = (data) => {
    if (data === "multiBtn2") {
      navigate('/addbankcard', { replace: false });
    }
  };

  const updateLoadingStatus = (data) => {
    setShowLoading(data);
  };

  const onScroll = () => {
    if (listViewRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listViewRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight;

      if (isNearBottom) {
        let newPageVal = pageConst.pageCount + 1;
        setConstants(previousState => {
          return { ...previousState, pageCount: newPageVal };
        });
      }
    }
  };

  const updateRecordList = (data) => {
    let tempData = [];

    for (let i = 0; i < data.length; i++) {
      tempData.push(
        <div key={i} className='pr-v w-100 col-view pd-15 br-5 mg-t-15 bg-custom-lightblue'>
          <div className='row-view sb-view ft-sz-15'>
            <div className='pd-2-8 br-5 bg-custom-blue'>
              Withdraw
            </div>
            <div className={`br-5 ${data[i]['w_status'] === "success" ? 'cl-green' : (data[i]['w_status'] === "rejected" ? 'cl-red' : 'cl-l-white')}`}>
              {data[i]['w_status'] === "success" ? 'Completed' : (data[i]['w_status'] === "rejected" ? 'Cancelled' : 'Processing')}
            </div>
          </div>

          <div className='row-view sb-view ft-sz-14 mg-t-15'>
            <span className='cl-white'>Balance:</span>
            <span className='ft-wgt-400 cl-custom-blue'>₹{data[i]['w_request']}</span>
          </div>

          <div className='row-view sb-view ft-sz-14 cl-white mg-t-10'>
            <span>Type:</span>
            <span>BANK CARD</span>
          </div>

          <div className='row-view sb-view ft-sz-14 cl-white mg-t-10'>
            <span className='cl-white'>Time</span>
            {data[i]["w_date"] + " " + data[i]["w_time"]}
          </div>

          <div className='row-view sb-view ft-sz-14 cl-white mg-t-10'>
            <span className='ft-sz-15 mg-t-5'>Order number</span>
            <div className='row-view' onClick={() => onIDClicked(data[i]['w_uniq_id'])}>
              <span>{data[i]['w_uniq_id']}</span>
              <img className="h-w-15 mg-l-10" src={require("../icons/blue_copy_icon.png")} />
            </div>
          </div>

          <div className='row-view sb-view ft-sz-14 mg-t-10'>
            <textarea className='ft-wgt-400 cl-custom-blue' disabled>{data[i]['w_remark'] || 'No remarks'}</textarea>
          </div>
        </div>
      );
    }

    setConstants(previousState => {
      return { ...previousState, recordList: tempData };
    });
  };

  const getWithdrawalRecords = async () => {
    updateLoadingStatus(true);
    try {
      const res = await fetch(API_ACCESS_URL + "?USER_ID=" + getStorage("uid") + "&PAGE_NUM=" + pageConst.pageCount, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'route': 'route-withdraw-records',
          'AuthToken': getStorage("secret"),
        }
      });

      const data = await res.json();
      updateLoadingStatus(false);

      if (data.status_code === "success") {
        updateRecordList(data.data);
      }
    } catch (error) {
      updateLoadingStatus(false);
      console.error("Error fetching withdrawal records:", error);
    }
  };

  const updateWithdrawalRemark = async (orderId, remark) => {
    try {
      const res = await fetch(API_ACCESS_URL + "/update-remark", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'AuthToken': getStorage("secret"),
        },
        body: JSON.stringify({
          order_id: orderId,
          remark: remark,
        }),
      });

      const data = await res.json();
      if (data.status_code === "success") {
        showToast("Remark updated successfully!", 2500, 0, 1);
        // Re-fetch records to reflect updated remark
        getWithdrawalRecords();
      } else {
        showToast("Failed to update remark", 2500, 0, 2);
      }
    } catch (error) {
      console.error("Error updating remark:", error);
      showToast("Error updating remark", 2500, 0, 2);
    }
  };

  useEffect(() => {
    getWithdrawalRecords();  // Fetch records when the component mounts
    const listInnerElement = listViewRef.current;

    if (listInnerElement) {
      listInnerElement.addEventListener("scroll", onScroll);

      // Clean-up on unmount
      return () => {
        listInnerElement.removeEventListener("scroll", onScroll);
      };
    }
  }, [pageConst.pageCount]);

  return (
    <div className="v-center">
      <div className="h-100vh pr-v res-wth ovf-scrl-y hide-sb app-bg">
        <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />
        <TopBar intentData={pageConst} multiBtn={true} multiBtn1="" multiBtn2="" updateState={topBarClickAction} />
        <LoadingDialog intentData={showLoading} />

        <div className="col-view mg-t-45">
          <div className="col-view br-right-t br-left-t mg-b-15">
            <div style={{ display: "flex", padding: "0px 0px 0 15px" }}>
              <div id="van-tabs-6-3" role="tab" className="card-container" tabIndex="-1" aria-selected="false" aria-controls="van-tab-10" data-allow-mismatch="attribute">
                <span className="van-tab__text">
              <div className="tabDiv" style={{color:"white"}}>
                  <svg
      viewBox="0 0 42 42"
      fill="#FFF"
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
    >
      <path
        d="M36.75 28.4375H26.25C25.5325 28.4375 24.9375 27.8425 24.9375 27.125C24.9375 26.4075 25.5325 25.8125 26.25 25.8125H36.75C37.4675 25.8125 38.0625 26.4075 38.0625 27.125C38.0625 27.8425 37.4675 28.4375 36.75 28.4375ZM36.75 35.4375H26.25C25.5325 35.4375 24.9375 34.8425 24.9375 34.125C24.9375 33.4075 25.5325 32.8125 26.25 32.8125H36.75C37.4675 32.8125 38.0625 33.4075 38.0625 34.125C38.0625 34.8425 37.4675 35.4375 36.75 35.4375ZM38.5 14.91V6.965C38.5 4.4975 37.38 3.5 34.5975 3.5H27.5275C24.745 3.5 23.625 4.4975 23.625 6.965V14.8925C23.625 17.3775 24.745 18.3575 27.5275 18.3575H34.5975C37.38 18.375 38.5 17.3775 38.5 14.91ZM18.375 14.91V6.965C18.375 4.4975 17.255 3.5 14.4725 3.5H7.4025C4.62 3.5 3.5 4.4975 3.5 6.965V14.8925C3.5 17.3775 4.62 18.3575 7.4025 18.3575H14.4725C17.255 18.375 18.375 17.3775 18.375 14.91ZM18.375 34.5975V27.5275C18.375 24.745 17.255 23.625 14.4725 23.625H7.4025C4.62 23.625 3.5 24.745 3.5 27.5275V34.5975C3.5 37.38 4.62 38.5 7.4025 38.5H14.4725C17.255 38.5 18.375 37.38 18.375 34.5975Z"
        fill="#FFF"
      />
    </svg>
    All
                  </div>
                </span>
              </div>
              <div id="van-tabs-6-3" role="tab" className="card-row" tabIndex="-1" aria-selected="false" aria-controls="van-tab-10" data-allow-mismatch="attribute">
                <span className="van-tab__text">
                  <div className="tabDiv">
                    <img className='h-40-p' src="https://ossimg.tirangaagent.com/Tiranga/payNameIcon/WithBeforeImgIcon_20240307174823m24t.png" alt="USDT" /> ARPAY
                  </div>
                </span>
              </div>
              <div id="van-tabs-6-3" role="tab" className="card-row" tabIndex="-1" aria-selected="false" aria-controls="van-tab-10" data-allow-mismatch="attribute">
                <span className="van-tab__text">
                  <div className="tabDiv">
                    <img className='h-40-p' src="https://ossimg.tirangaagent.com/Tiranga/payNameIcon/WithBeforeImgIcon_20231130131452qto4.png" alt="USDT" /> BANK
                  </div>
                </span>
              </div>

              <div id="van-tabs-6-3" role="tab" className="card-row" tabIndex="-1" aria-selected="false" aria-controls="van-tab-10" data-allow-mismatch="attribute">
                <span className="van-tab__text">
                  <div className="tabDiv">
                    <img className='h-40-p' src="https://ossimg.tirangaagent.com/Tiranga/payNameIcon/WithBeforeImgIcon_20231130131415dtww.png" alt="USDT" /> USDT
                  </div>
                </span>
              </div>
            </div>
            <div className="TeamReport__C-head-line2 pd-5-15" style={{ height: "55px" }}>
              <div
                className="TeamReport_head2_child"
                style={{ cursor: "pointer" }}
              >
                <span className="default">
                  All
                </span>

                <i className="fas fa-chevron-down"></i>
              </div>
              <div
                className="TeamReport_head2_child2"
                style={{ cursor: "pointer" }}
              >
                <span className="default" style={{ fontSize: "smaller" }}>2025-02-20/2025-02-31</span>
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>


            <div className='col-view pd-0-15'>
              {pageConst.recordList}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllBankCards;
